import React, { Component } from 'react';
import PageHeader from '../../components/PageHeader';
import Container from '../../components/Container';
import DispatchList from '../../components/DispatchList';

class MerchantPickupList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const breadCrumbs = [
      {
        breadcrumbName: 'Packages',
      },
      {
        breadcrumbName: 'Merchant Pickup',
      },
      {
        breadcrumbName: 'List',
      },
    ];

    const dispatchListColumns = [
      {
        Header: 'Dispatch ID',
        accessor: 'ph_id',
      },
      {
        Header: 'Courier',
        accessor: 'driver',
      },
      {
        Header: 'Merchant',
        accessor: 'merchant',
      },
      {
        Header: 'Status',
        accessor: 'status',
      },
      {
        Header: 'Created At',
        accessor: 'created_at',
      },
    ];

    const customFilter = {
      id: 'type',
      value: 'merchant',
    };

    return (
      <div className="MerchantPickupList">
        <PageHeader title="Merchant Pickup" routes={breadCrumbs} />
        <Container>
          <DispatchList
            hasExport={false}
            dispatchListColumns={dispatchListColumns}
            customFilter={customFilter}
            fetchText="Fetching Merchant Pickup List. . ."
            urlEndpoint="/merchant-pickup"
            typeDispatch="merchant"
            isCustomerMerchantPickUp
          />
        </Container>
      </div>
    );
  }
}

export default MerchantPickupList;
